import React from "react";
import styled from "styled-components";

const StyledNight = styled.svg`
  z-index: 2;
  position: absolute;
  left: 1;
  top: 1;
  width: 84vw;
  height: 78vh;
`;

const NightSky = () => {
  return (
    <StyledNight
      id="stars-container"
      viewBox="0 0 1200 650"
      preserveAspectRatio="none"
    >
      <g id="lowerStars">
        <linearGradient
          id="SVGID_1_"
          x1="599.9995"
          x2="599.9995"
          y2="650"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#08070f" />
          <stop offset=".322" stopColor="#0f1721" />
          <stop offset=".829" stopColor="#1c3844" />
          <stop offset=".8945" stopColor="#1d3642" />
          <stop offset=".9278" stopColor="#1e313a" />
          <stop offset=".9536" stopColor="#21282d" />
          <stop offset=".9757" stopColor="#261a1a" />
          <stop offset=".9777" stopColor="#261918" />
        </linearGradient>
        <path fill="url(#SVGID_1_)" d="M0 0h1200v650H0z" />
        <g
          fillRule="evenodd"
          stroke="#FCFCFC"
          strokeMiterlimit="10"
          clipRule="evenodd"
        >
          <path
            id="star27_1_"
            fill="#636256"
            strokeWidth=".6086"
            d="M473.2 169.9c.1.7.8.9 1.1 1.6-1 .2-2.4-.6-2.4-1.3"
          />
          <path
            id="star26_1_"
            fill="#636256"
            strokeWidth="1.0882"
            d="M774.4 435.4c.6 1.4-1.1 1.3-1.9 2.6.3-1.6-.4-2.7.9-3.1"
          />
          <path
            id="star25_1_"
            fill="#989685"
            strokeWidth="1.0882"
            d="M383.4 25.7c0 .6-.4 1-1.1 1-.5-.1-.9-.4-.9-1"
          />
          <path
            id="star24_1_"
            fill="#C4C5A6"
            strokeWidth="1.0882"
            d="M22.5 262.5c.6 0 1 .3 1 .9 0 .6-.3.9-.9 1"
          />
          <path
            id="star23_1_"
            fill="#C4C5A6"
            strokeWidth="1.0882"
            d="M609.4 229.2c-.4-.1-.7-.4-.8-.8 0-.6.3-.9.9-1"
          />
          <path
            id="star22_1_"
            fill="#989685"
            strokeWidth="1.0882"
            d="M1061.7 391c0 .6-.3 1-.8 1-.6.1-1-.3-1-.9"
          />
          <path
            id="star21_1_"
            fill="#C4C5A6"
            strokeWidth="1.0882"
            d="M770.2 107.5c.6.1.9.5.8 1.1-.1.6-.5.9-1.1.7"
          />
          <path
            id="star20_1_"
            fill="#525045"
            strokeWidth="1.0882"
            d="M1047.9 504.5c-.6 0-1-.3-.9-1 0-.6.5-.9 1-.9"
          />
          <path
            id="start19_1_"
            fill="#525045"
            strokeWidth="1.0882"
            d="M959.7 260.2c.6.1.9.5.9 1.1-.1.6-.6.9-1.1.7"
          />
          <path
            id="star18_1_"
            fill="#525045"
            strokeWidth="1.0882"
            d="M1095.6 12.1c-.1 0-.3 0-.4.1-.6-.6-.8-1.2-.1-1.8"
          />
          <path
            id="star17_1_"
            fill="#48463D"
            strokeWidth="1.0882"
            d="M1179.9 175c0 .5-.2.8-.7.9-.6.1-1-.2-1.1-.8"
          />
          <path
            id="start16_1_"
            fill="#3B3931"
            strokeWidth="1.0882"
            d="M716.9 182.7c-.1-.6.3-1 .8-1.1.6-.1 1.1.3 1 .9"
          />
          <path
            id="star15_1_"
            fill="#3B3931"
            strokeWidth="1.0882"
            d="M82.6 108.7c-.6.2-1-.2-1-.8 0-.6.4-.9 1-1"
          />
          <path
            id="star14_1_"
            fill="#3B3931"
            strokeWidth="1.0882"
            d="M951.1 65.3c0-.5.3-.8.8-.8s.7.3.8.8"
          />
          <path
            id="star13_1_"
            fill="#3B3931"
            strokeWidth="1.0882"
            d="M1109.8 18.8c-.6.1-1 0-1.1-.7-.1-.4.2-.8.6-.9"
          />
          <path
            id="star12_1_"
            fill="#989685"
            strokeWidth="1.0882"
            d="M865.8 494.9c-.1.5-.4.7-.9.7-.6-.1-.8-.5-.7-1.1"
          />
          <path
            id="star11_1_"
            fill="#3B3931"
            strokeWidth="1.0882"
            d="M456.8 287.6c0-.6.3-.9 1-.9.4 0 .8.2.8.7"
          />
          <path
            id="star10_1_"
            fill="#3B3931"
            strokeWidth="1.0882"
            d="M1063.1 41.1c.2 0 .5.3.6.6.1.4-.1.8-.6.9"
          />
          <path
            id="star9_1_"
            fill="#525045"
            strokeWidth="1.0882"
            d="M130.8 478c-.1 0-.3 0-.4.1-.6-.6-.8-1.2-.1-1.8"
          />
          <path
            id="star8_1_"
            fill="#525045"
            strokeWidth="1.0882"
            d="M409.1 228.1c.1.4-.2.8-.7.7-.2 0-.5-.3-.6-.5"
          />
          <path
            id="star7_1_"
            fill="#48463D"
            strokeWidth="1.0882"
            d="M371.4 64.8c0 .5-.2.8-.7.9-.6.1-1.1-.1-1.2-.7"
          />
          <path
            id="star6_1_"
            fill="#525045"
            strokeWidth="1.0882"
            d="M196 454.1c.6.1.9.5.8 1.1-.1.6-.6.9-1.1.7"
          />
          <path
            id="star5_1_"
            fill="#FFF"
            strokeWidth="1.0882"
            d="M327.8 333.1c-.2.6-.6.8-1.1.7-.6-.2-.8-.6-.7-1.2"
          />
          <path
            id="star4_1_"
            fill="#FCFCFC"
            strokeWidth="1.0882"
            d="M1052.1 152.7c.6.1.9.4.9 1-.2.6-.6.9-1.1.8"
          />
          <path
            id="star3_1_"
            fill="#636256"
            strokeWidth="1.0882"
            d="M698.1 439.5c-.8.5-1.1.7-1.3.7-.2 0-.3-.4-.5-.6"
          />
          <path
            id="star2_1_"
            fill="#FCFCFC"
            strokeWidth="1.0882"
            d="M685.3 426c-.2-.6 0-1 .6-1.2.6-.1 1 .2 1.2.7"
          />
          <path
            id="star1_2_"
            fill="#FCFCFC"
            strokeWidth="1.0882"
            d="M99.8 195.8c0 .7-.4 1.2-1.1 1.1-.6-.1-.8-.5-.9-1.1"
          />
        </g>
      </g>
    </StyledNight>
  );
};

export default NightSky;
/*
<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="650">
  <g id="lowerStars">
    <linearGradient id="SVGID_1_" x1="599.9995" x2="599.9995" y2="650" gradientUnits="userSpaceOnUse">
      <stop offset="0" style="stop-color:#08070f"/>
      <stop offset=".322" style="stop-color:#0f1721"/>
      <stop offset=".829" style="stop-color:#1c3844"/>
      <stop offset=".8945" style="stop-color:#1d3642"/>
      <stop offset=".9278" style="stop-color:#1e313a"/>
      <stop offset=".9536" style="stop-color:#21282d"/>
      <stop offset=".9757" style="stop-color:#261a1a"/>
      <stop offset=".9777" style="stop-color:#261918"/>
    </linearGradient>
    <path fill="url(#SVGID_1_)" d="M0 0h1200v650H0z"/>
    <g fill-rule="evenodd" stroke="#FCFCFC" stroke-miterlimit="10" clip-rule="evenodd">
      <path id="star27_1_" fill="#636256" stroke-width=".6086" d="M473.2 169.9c.1.7.8.9 1.1 1.6-1 .2-2.4-.6-2.4-1.3"/>
      <path id="star26_1_" fill="#636256" stroke-width="1.0882" d="M774.4 435.4c.6 1.4-1.1 1.3-1.9 2.6.3-1.6-.4-2.7.9-3.1"/>
      <path id="star25_1_" fill="#989685" stroke-width="1.0882" d="M383.4 25.7c0 .6-.4 1-1.1 1-.5-.1-.9-.4-.9-1"/>
      <path id="star24_1_" fill="#C4C5A6" stroke-width="1.0882" d="M22.5 262.5c.6 0 1 .3 1 .9 0 .6-.3.9-.9 1"/>
      <path id="star23_1_" fill="#C4C5A6" stroke-width="1.0882" d="M609.4 229.2c-.4-.1-.7-.4-.8-.8 0-.6.3-.9.9-1"/>
      <path id="star22_1_" fill="#989685" stroke-width="1.0882" d="M1061.7 391c0 .6-.3 1-.8 1-.6.1-1-.3-1-.9"/>
      <path id="star21_1_" fill="#C4C5A6" stroke-width="1.0882" d="M770.2 107.5c.6.1.9.5.8 1.1-.1.6-.5.9-1.1.7"/>
      <path id="star20_1_" fill="#525045" stroke-width="1.0882" d="M1047.9 504.5c-.6 0-1-.3-.9-1 0-.6.5-.9 1-.9"/>
      <path id="start19_1_" fill="#525045" stroke-width="1.0882" d="M959.7 260.2c.6.1.9.5.9 1.1-.1.6-.6.9-1.1.7"/>
      <path id="star18_1_" fill="#525045" stroke-width="1.0882" d="M1095.6 12.1c-.1 0-.3 0-.4.1-.6-.6-.8-1.2-.1-1.8"/>
      <path id="star17_1_" fill="#48463D" stroke-width="1.0882" d="M1179.9 175c0 .5-.2.8-.7.9-.6.1-1-.2-1.1-.8"/>
      <path id="start16_1_" fill="#3B3931" stroke-width="1.0882" d="M716.9 182.7c-.1-.6.3-1 .8-1.1.6-.1 1.1.3 1 .9"/>
      <path id="star15_1_" fill="#3B3931" stroke-width="1.0882" d="M82.6 108.7c-.6.2-1-.2-1-.8 0-.6.4-.9 1-1"/>
      <path id="star14_1_" fill="#3B3931" stroke-width="1.0882" d="M951.1 65.3c0-.5.3-.8.8-.8s.7.3.8.8"/>
      <path id="star13_1_" fill="#3B3931" stroke-width="1.0882" d="M1109.8 18.8c-.6.1-1 0-1.1-.7-.1-.4.2-.8.6-.9"/>
      <path id="star12_1_" fill="#989685" stroke-width="1.0882" d="M865.8 494.9c-.1.5-.4.7-.9.7-.6-.1-.8-.5-.7-1.1"/>
      <path id="star11_1_" fill="#3B3931" stroke-width="1.0882" d="M456.8 287.6c0-.6.3-.9 1-.9.4 0 .8.2.8.7"/>
      <path id="star10_1_" fill="#3B3931" stroke-width="1.0882" d="M1063.1 41.1c.2 0 .5.3.6.6.1.4-.1.8-.6.9"/>
      <path id="star9_1_" fill="#525045" stroke-width="1.0882" d="M130.8 478c-.1 0-.3 0-.4.1-.6-.6-.8-1.2-.1-1.8"/>
      <path id="star8_1_" fill="#525045" stroke-width="1.0882" d="M409.1 228.1c.1.4-.2.8-.7.7-.2 0-.5-.3-.6-.5"/>
      <path id="star7_1_" fill="#48463D" stroke-width="1.0882" d="M371.4 64.8c0 .5-.2.8-.7.9-.6.1-1.1-.1-1.2-.7"/>
      <path id="star6_1_" fill="#525045" stroke-width="1.0882" d="M196 454.1c.6.1.9.5.8 1.1-.1.6-.6.9-1.1.7"/>
      <path id="star5_1_" fill="#FFF" stroke-width="1.0882" d="M327.8 333.1c-.2.6-.6.8-1.1.7-.6-.2-.8-.6-.7-1.2"/>
      <path id="star4_1_" fill="#FCFCFC" stroke-width="1.0882" d="M1052.1 152.7c.6.1.9.4.9 1-.2.6-.6.9-1.1.8"/>
      <path id="star3_1_" fill="#636256" stroke-width="1.0882" d="M698.1 439.5c-.8.5-1.1.7-1.3.7-.2 0-.3-.4-.5-.6"/>
      <path id="star2_1_" fill="#FCFCFC" stroke-width="1.0882" d="M685.3 426c-.2-.6 0-1 .6-1.2.6-.1 1 .2 1.2.7"/>
      <path id="star1_2_" fill="#FCFCFC" stroke-width="1.0882" d="M99.8 195.8c0 .7-.4 1.2-1.1 1.1-.6-.1-.8-.5-.9-1.1"/>
    </g>
  </g>
</svg>
*/
